@file:OptIn(InternalResourceApi::class)

package waifupics.modules.core.core_ui.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String =
    "composeResources/waifupics.modules.core.core_ui.generated.resources/"

@delegate:ResourceContentHash(-1_403_334_444)
internal val Res.string.age_rating: StringResource by lazy {
      StringResource("string:age_rating", "age_rating", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10, 34),
      ))
    }

@delegate:ResourceContentHash(-71_469_583)
internal val Res.string.borderline: StringResource by lazy {
      StringResource("string:borderline", "borderline", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 45, 34),
      ))
    }

@delegate:ResourceContentHash(111_733_814)
internal val Res.string.close: StringResource by lazy {
      StringResource("string:close", "close", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 80, 21),
      ))
    }

@delegate:ResourceContentHash(1_839_709_585)
internal val Res.string.copy_image_source: StringResource by lazy {
      StringResource("string:copy_image_source", "copy_image_source", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 102, 37),
      ))
    }

@delegate:ResourceContentHash(187_981_282)
internal val Res.string.copy_palette_color: StringResource by lazy {
      StringResource("string:copy_palette_color", "copy_palette_color", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 140, 46),
      ))
    }

@delegate:ResourceContentHash(-1_867_054_547)
internal val Res.string.explicit_18: StringResource by lazy {
      StringResource("string:explicit_18", "explicit_18", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 187, 39),
      ))
    }

@delegate:ResourceContentHash(-1_904_475_386)
internal val Res.string.image_author: StringResource by lazy {
      StringResource("string:image_author", "image_author", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 227, 28),
      ))
    }

@delegate:ResourceContentHash(-1_691_003_126)
internal val Res.string.image_copied: StringResource by lazy {
      StringResource("string:image_copied", "image_copied", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 256, 28),
      ))
    }

@delegate:ResourceContentHash(1_512_401_708)
internal val Res.string.image_copy_failed: StringResource by lazy {
      StringResource("string:image_copy_failed", "image_copy_failed", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 285, 65),
      ))
    }

@delegate:ResourceContentHash(1_484_235_183)
internal val Res.string.image_not_provided: StringResource by lazy {
      StringResource("string:image_not_provided", "image_not_provided", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 351, 42),
      ))
    }

@delegate:ResourceContentHash(515_254_300)
internal val Res.string.image_palette_copy_hint: StringResource by lazy {
      StringResource("string:image_palette_copy_hint", "image_palette_copy_hint", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 394, 63),
      ))
    }

@delegate:ResourceContentHash(80_124_366)
internal val Res.string.image_palette_title: StringResource by lazy {
      StringResource("string:image_palette_title", "image_palette_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 458, 47),
      ))
    }

@delegate:ResourceContentHash(920_704_925)
internal val Res.string.image_source: StringResource by lazy {
      StringResource("string:image_source", "image_source", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 571, 28),
      ))
    }

@delegate:ResourceContentHash(-1_528_395_013)
internal val Res.string.image_source_open_failed: StringResource by lazy {
      StringResource("string:image_source_open_failed", "image_source_open_failed", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 506, 64),
      ))
    }

@delegate:ResourceContentHash(254_778_861)
internal val Res.string.image_tags: StringResource by lazy {
      StringResource("string:image_tags", "image_tags", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 600, 26),
      ))
    }

@delegate:ResourceContentHash(1_409_710_461)
internal val Res.string.open_image_source: StringResource by lazy {
      StringResource("string:open_image_source", "open_image_source", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 627, 41),
      ))
    }

@delegate:ResourceContentHash(-1_582_237_413)
internal val Res.string.safe_for_work: StringResource by lazy {
      StringResource("string:safe_for_work", "safe_for_work", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 669, 41),
      ))
    }

@delegate:ResourceContentHash(-1_503_567_278)
internal val Res.string.suggestive: StringResource by lazy {
      StringResource("string:suggestive", "suggestive", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 711, 34),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString0Resources(map: MutableMap<String, StringResource>) {
  map.put("age_rating", Res.string.age_rating)
  map.put("borderline", Res.string.borderline)
  map.put("close", Res.string.close)
  map.put("copy_image_source", Res.string.copy_image_source)
  map.put("copy_palette_color", Res.string.copy_palette_color)
  map.put("explicit_18", Res.string.explicit_18)
  map.put("image_author", Res.string.image_author)
  map.put("image_copied", Res.string.image_copied)
  map.put("image_copy_failed", Res.string.image_copy_failed)
  map.put("image_not_provided", Res.string.image_not_provided)
  map.put("image_palette_copy_hint", Res.string.image_palette_copy_hint)
  map.put("image_palette_title", Res.string.image_palette_title)
  map.put("image_source", Res.string.image_source)
  map.put("image_source_open_failed", Res.string.image_source_open_failed)
  map.put("image_tags", Res.string.image_tags)
  map.put("open_image_source", Res.string.open_image_source)
  map.put("safe_for_work", Res.string.safe_for_work)
  map.put("suggestive", Res.string.suggestive)
}
